
  var _styles = {
  "activity-subscribe-section-container": {
    "width": "8.72rem",
    "height": "1.17333rem",
    "borderRadius": "1.17333rem",
    "overflow": "hidden",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-around"
  },
  "activity-subscribe-section-countdown": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "flex": 1
  },
  "activity-subscribe-section-button": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "3.04rem"
  },
  "activity-subscribe-section-divider": {
    "width": "0.02667rem",
    "height": "0.37333rem",
    "backgroundColor": "rgba(0,0,0,0.1)"
  }
};



  module.exports = _styles;
  